/* 夏侯淵傳・第 3 章：救祁山（建安十九年，214）
 * 史實：《三國志·夏侯淵傳》「超奔漢中，還圍祁山。叙等急求救，諸將議者欲須太祖節度。淵曰：『公在鄴，反覆四千里，比報，叙等必敗，非救急也。』
 *       遂行，使張郃督步騎五千在前，從陳倉狹道入，淵自督糧在後。郃至渭水上，超將氐羌數千逆郃。未戰，超走，郃進軍收超軍器械。淵到，諸縣皆已降。」
 *       皇甫謐《列女傳》（裴注）：趙昂與妻王異「保祁山，爲超所圍，三十日救兵到，乃解」。
 * 流程：陳倉營裡有等著送信去鄴城的使者——去請示就失敗（比報，叙等必敗）。直接出發：張郃帶先鋒在前，夏侯淵押糧車在後；
 *       糧車離張郃太遠，張郃就停下來等。狹道裡氐兵伏擊，貼著糧車會讓糧車受損。祁山被圍的日數一直在加，滿 30 天失守。
 *       張郃到渭水上：先鋒還在、日子還早，馬超就不戰而走；否則要把馬超打退。收超軍器械，到祁山解圍。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, allyTick, boss, hero, rout, TROOPS } from '../kit.ts';
import { cart, cartsTick, XTROOPS, F } from './xiahouyuan_kit.ts';
import { CHENCANG, ENVOY, PATH, AMBUSH, WEI, QISHAN } from '../maps/xiahouyuan_qishan.ts';

const LV = 11, DAY0 = 8, DAY = 4, FALL = 30, SCARE = 21, TETHER = 1700, WEI_I = 5;
const DI = F(XTROOPS.di, '氐兵', 460, 26, 245), QIANG = F(XTROOPS.qiang, '羌兵', 520, 30, 250);

export default {
  id: 'xiahouyuan-3', map: 'xiahouyuan_qishan', hero: 'xiahouyuan',
  title: '第 3 章　救祁山', year: '建安十九年（214）',
  brief: {
    quote: [{ text: '公在鄴，反覆四千里，比報，叙等必敗，非救急也。', src: '《三國志·魏書·夏侯淵傳》' }],
    text: '馬超在冀城失敗後投奔張魯，又從漢中借兵回來包圍祁山。姜敘等人向長安的夏侯淵求救，諸將想先請示遠在鄴城的曹操。',
    goals: ['不等回覆，直接出兵（去請示就來不及了）', '押著糧車跟上張郃的先鋒，走過陳倉狹道', '祁山被圍滿 30 天之前趕到'],
  },
  words: { ally: '魏軍', foe: '氐羌兵' },
  stars: [
    { text: '如史：馬超未戰而走', ok: (m) => !!m.vars.noFight },
    { text: '祁山被圍未滿 25 天就解圍', ok: (m) => m.vars.dayAt != null && m.vars.dayAt < 25 },
    { text: '糧車的耐久保住一半以上', ok: (m) => m.vars.cart.hp >= 50 },
  ],
  steps: [
    { // 1. 出兵、行軍
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = CHENCANG[0] - 100; me.y = CHENCANG[1] + 120;
        V.t0 = w.t; V.day = DAY0; V.zi = 0; V.waitT = 0;
        V.cart = cart(m, me.x + 160, me.y + 40, { follow: me, sp: 225, gap: 150 });
        V.zh = ally(w, 'zhanghe', PATH[0][0], PATH[0][1], LV); V.zh.hold = PATH[0].slice();
        V.van = Array.from({ length: 8 }, (_, i) => { const u = m.recruit(PATH[0][0] + 100 + (i % 4) * 50, PATH[0][1] - 60 + Math.floor(i / 4) * 100, '先鋒'); u.spec = TROOPS.wei; m.join(u, V.zh); return u; });
        V.envoy = m.folk(ENVOY[0], ENVOY[1], { name: '使者', still: true, near: 1 });
        m.mark('envoy', ENVOY[0], ENVOY[1], '使者（請示太祖）', true);
        m.mark('go', PATH[WEI_I][0], PATH[WEI_I][1], '渭水');
        V.amb = AMBUSH.map(([x, y]) => ({ x, y, done: false }));
        m.line('部將', '是不是先派人去鄴城，請魏公節度？');
        m.after(3, () => m.line('提示', '要去請示，走到使者那裡；要出兵，押著糧車往西走。'));
        m.obj('day', '');
        m.obj('go', '押糧跟上張郃，走到渭水');
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars, zh = V.zh;
        if (m.near(me, ENVOY[0], ENVOY[1], 140)) { V.asked = true; m.lose('等到鄴城回覆，姜敘早已敗了（比報，叙等必敗）'); return false; }
        if (!V.went && me.x < CHENCANG[0] - 500) { V.went = true; m.unmark('envoy'); m.line('夏侯淵', '公在鄴，反覆四千里，比報，叙等必敗，非救急也。走！'); m.after(3, () => m.line('張郃', '末將帶先鋒在前，走陳倉狹道！')); }
        if (!V.went) return false;
        march(m, w, dt);
        return V.zi >= WEI_I && m.near(zh, PATH[WEI_I][0], PATH[WEI_I][1], 200);
      },
    },
    { // 2. 渭水上：馬超迎戰
      enter(m, w) {
        const V = m.vars;
        m.done('go'); m.unmark('go');
        const vanN = m.alive(V.van).length;
        V.noFight = V.day < SCARE && vanN >= 6;
        V.mc = boss(w, hero('machao'), WEI[0] - 700, WEI[1], { name: '馬超', hp: 5000, atk: 58, armor: 10, ms: 270 });
        V.foes = Array.from({ length: 8 }, (_, i) => m.foe('huangjin', WEI[0] - 600 + (i % 4) * 90, WEI[1] - 200 + Math.floor(i / 4) * 400, i % 2 ? QIANG : DI));
        m.card('郃至渭水上，超將氐羌數千逆郃。', '《夏侯淵傳》');
        if (V.noFight) {
          for (const u of V.foes.concat(V.mc)) u.untargetable = true;
          m.after(3, () => m.line('馬超', '夏侯淵來得這麼快？……撤！'));
          m.after(5, () => { m.card('未戰，超走，郃進軍收超軍器械。', '《夏侯淵傳》'); rout(m, w, V.foes.concat(V.mc), [200, 3800]); arms(m); });
        } else {
          m.line('張郃', `${vanN < 6 ? '先鋒折損太多' : '來得太晚'}，馬超不怕我們——迎戰！`);
          for (const u of V.foes.concat(V.mc)) u.home = [V.zh.x, V.zh.y];
          m.obj('mc', '擊退馬超');
          m.mark('mc', V.mc.x, V.mc.y, '馬超', false, V.mc);
          const pk = w.xPreKill;
          w.xPreKill = function (src, t) { if (t === V.mc) { t.hp = 1; return true; } return pk.call(this, src, t); };
        }
      },
      tick(m, w, dt) {
        const V = m.vars;
        march(m, w, dt, true);
        if (V.noFight) return m.t > 6;
        if (V.mc.hp > V.mc.maxHp * 0.5) return false;
        m.done('mc'); m.unmark('mc');
        m.line('馬超', '……退回漢中！'); rout(m, w, w.units.filter((u) => u.team === 1), [200, 3800]); arms(m);
        return true;
      },
    },
    { // 3. 到祁山
      enter(m, w) {
        const V = m.vars;
        V.zh.hold = [QISHAN[0] + 250, QISHAN[1] + 150];
        m.mark('qs', QISHAN[0], QISHAN[1], '祁山');
        m.obj('qs', '到祁山解圍');
        m.after(2, () => m.line('提示', '馬超留下的軍器散在渭水邊，可以撿起來。'));
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars;
        march(m, w, dt, true);
        return m.near(me, QISHAN[0], QISHAN[1], 450);
      },
    },
    { // 4. 解圍
      enter(m, w) {
        const V = m.vars;
        V.dayAt = V.day; m.done('qs'); m.unmark('qs'); m.done('day');
        m.card('淵到，諸縣皆已降。', '《夏侯淵傳》');
        m.after(4, () => m.line('姜敘', '救兵到了！祁山守住了！'));
        m.after(5, () => m.card('（趙昂與妻王異）保祁山，爲超所圍，三十日救兵到，乃解。', '皇甫謐《列女傳》（裴注）'));
        m.after(10, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w) {
    const V = m.vars;
    if (!w.player.alive) m.lose('夏侯淵陣亡');
    if (m.over || !V.went || m.i >= 3) return;
    V.day = DAY0 + (w.t - V.t0) / DAY;
    m.get('day').text = `祁山被圍第 ${Math.floor(V.day)} 天（30 天失守）　糧車 ${Math.max(0, Math.round(V.cart.hp))}%`;
    if (V.day >= FALL) m.lose('祁山失守');
  },
};

// 行軍：糧車跟著夏侯淵；張郃照路線走，糧車太遠就停下來等；狹道裡的伏兵
function march(m, w, dt, free) {
  const me = w.player, V = m.vars, zh = V.zh;
  const r = cartsTick(m, w, dt, [V.cart], 3);
  if (r.lost.length) { m.lose('糧車被劫，先鋒斷糧'); return; }
  allyTick(w, zh, null, 420);
  if (free) return;
  if (m.near(zh, zh.hold[0], zh.hold[1], 140) && V.zi < WEI_I) {
    const nx = PATH[V.zi + 1];
    if (SG.gd(nx[0], nx[1], V.cart.x, V.cart.y) < TETHER) { V.zi++; zh.hold = nx.slice(); } // 下一個路點離糧車不遠才往前走
    else if ((V.waitT -= dt) <= 0) { V.waitT = 10; m.line('張郃', '糧車還沒跟上，先鋒在這裡等一等。'); }
  }
  for (const a of V.amb) if (!a.done && (m.near(zh, a.x, a.y, 650) || m.near(me, a.x, a.y, 650))) {
    a.done = true; m.line('氐兵', '殺！');
    for (let i = 0; i < 5; i++) { const u = m.foe('huangjin', a.x - 200 + (i % 3) * 120, a.y + (i % 2 ? 260 : -260), DI); u.home = i % 2 ? [V.cart.x, V.cart.y] : [zh.x, zh.y]; }
  }
}
// 超軍器械：散在渭水西岸的拾獲
function arms(m) {
  [[WEI[0] - 300, WEI[1] - 150, 'gold', { n: 120, name: '馬超軍器械' }], [WEI[0] - 500, WEI[1] + 140, 'gold', { n: 120, name: '馬超軍器械' }], [WEI[0] - 700, WEI[1] - 40, 'food', { n: 0.4, name: '馬超軍糧' }]].forEach(([x, y, k, o]) => m.loot(x, y, k, o));
}
